import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { DateField } from "@/components/DateField";
import { api, download, errMsg } from "@/lib/api";
import { DecisionTal } from "@/components/DecisionTal";

const REPONSES = [["accepte", "Accepte la hausse"], ["refuse", "Refuse la hausse (reste)"], ["quitte", "Quitte le logement"]];
export const LIB_REPONSE = Object.fromEntries(REPONSES);

export const ReponseAvis = ({ l, onDone }) => {
  const h = l.hausse;
  const [rep, setRep] = useState(h.reponse || "");
  const [date, setDate] = useState(h.reponse_le || new Date().toISOString().slice(0, 10));
  const [busy, setBusy] = useState(false);
  const envoyer = async (corps, msg) => {
    setBusy(true);
    try { await api.post(`/locataires/${l.id}/reponse-avis`, corps); toast.success(msg); onDone(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-md border border-slate-200 p-3 space-y-2" data-testid="reponse-avis">
      <p className="text-xs font-semibold">Réponse du locataire</p>
      <div className="flex flex-wrap items-center gap-2">
        <select value={rep} onChange={(e) => setRep(e.target.value)} className="h-8 rounded-md border border-input bg-white px-2 text-xs" data-testid="reponse-select">
          <option value="">Pas encore de réponse</option>{REPONSES.map(([k, lib]) => <option key={k} value={k}>{lib}</option>)}</select>
        <DateField value={date} onChange={setDate} className="h-8 w-40 text-xs" data-testid="reponse-date" />
        <Button size="sm" className="h-8 text-xs bg-emerald-700 hover:bg-emerald-800" disabled={!rep || busy} onClick={() => envoyer({ reponse: rep, date }, "Réponse enregistrée")} data-testid="reponse-enregistrer">
          {busy && <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />}Enregistrer</Button>
      </div>
      <p className="text-[11px] text-slate-500">Accepte : les dates du bail passent à la nouvelle période. Quitte : départ à la fin du bail. Sans réponse dans le mois suivant l'avis, le locataire est réputé avoir accepté.</p>
      {h.reponse === "refuse" && !h.decision && (
        <label className="flex items-center gap-2 text-xs text-amber-800" data-testid="reponse-tal">
          <input type="checkbox" checked={!!h.tal_depose} onChange={(e) => envoyer({ tal_depose: e.target.checked }, "Suivi TAL mis à jour")} data-testid="reponse-tal-depose" />
          Demande de fixation de loyer déposée au TAL (à faire dans le mois suivant le refus reçu le {h.reponse_le}). Le loyer actuel reste attendu en attendant.
        </label>
      )}
      {h.reponse === "refuse" && (
        <Button size="sm" variant="outline" className="h-8 text-xs" onClick={() => download(`/locataires/${l.id}/dossier-tal`, {}, "dossier-tal.pdf").catch((e) => toast.error(errMsg(e)))} data-testid="reponse-dossier-tal">
          Dossier de demande de fixation de loyer (PDF)
        </Button>
      )}
      {h.reponse === "refuse" && <DecisionTal l={l} onDone={onDone} />}
    </div>
  );
};
